export default "__VITE_ASSET__FgStqprQ__"